import { Config } from "./config/Config";
import { IWixStoreCollectionsList } from "../../src/wix-api/typedefs/IWixStoreCollectionsList";
import { WixApiCall } from "./WixApiCall";
import { MenuItemImage } from "./editor/MenuItemImage";
import { GlobalEventBus } from "./events/GlobalEventBus";
import { EventTypes } from "./events/EventTypes";

export class CategoriesLister extends WixApiCall{
  private currentCollections: IWixStoreCollectionsList | undefined;
  constructor(baseUrl:string = Config.API_BASE_URL) {
    super(baseUrl);
  }
  async getCategories(): Promise<MenuItemImage[]>{
    GlobalEventBus.dispatchEvent({
      type: EventTypes.LOADING,
      eventData: 'getCategories'
    });
    const response = await fetch(`${this.baseUrl}getcollections`);
    const json: IWixStoreCollectionsList = await response.json();
    this.currentCollections = json;
    const output: MenuItemImage[] = [];
    for (const item of json.items){
      if (item._id !== '00000000-000000-000000-000000000001') {
        output.push(new MenuItemImage(GlobalEventBus, 'category_' + item._id, item.mainMedia));
      };
    }
    GlobalEventBus.dispatchEvent({
      type: EventTypes.LOADED,
      eventData: 'getCategories'
    })
    return output;
  }
}
